import { KYMW1104Model } from './../kymw1104.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報初期処理クラス
 *
 * @export UpdateItemCodeForCoopService
 * @class UpdateItemCodeForCoopService
 * @extends {PlessResponder}
 */
@Injectable()
export class UpdateItemCodeForCoopService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1104Model;
  private vo: any;
  private mode: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateItemCodeForCoopService
   */
  private getBody(): PlessRequest {
    const itemCodes = this.vo.itemCodeList.map(ic => ({
      condition: {
        CoopCode: ic.CoopCode.toString(),
        ItemCode: ic.ItemCode.toString()
      }
    }));

    return new PlessRequest({
      update: {
        PCodeData: {
          condition: {
            PCode: this.vo.pCode
          }
        },
        ItemCodeList: {
          combination: itemCodes
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof UpdateItemCodeForCoopService
   */
  execute(model: KYMW1104Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateItemCodeForCoop', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateItemCodeForCoopService
   */
  success(data: any): void {
    this.model.kymw1104Component.reloadKYMW1104();
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }

}
